export const INSURED_ROLE_CODE = 'insured';
export const REPORTER_ROLE_CODE = 'reporter';
export const PATIENT_ROLE_CODE = 'injured';
